import { render, staticRenderFns } from "./FollowUp.vue.js?vue&type=template&id=75cf072b!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=template&id=75cf072b"
import script from "./FollowUp.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=script&lang=js"
export * from "./FollowUp.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=script&lang=js"
import style0 from "./FollowUp.vue.scss?vue&type=style&index=0&id=75cf072b&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FollowUp.vue?vue&type=style&index=0&id=75cf072b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports